// extracted by mini-css-extract-plugin
export default {"content":"JBCVIUIb","mobile":"mobile","text":"UGnh40Xc","headline":"cyPG4S9f","icon":"sU1cAvTe","image":"Eso6d8iT","social":"YrQJuwHU","time":"zrxAtj9C"};